import React from 'react';
import { STATUS_MAP } from '../../utils/catalogs';
import { getChartColor } from '../../utils/chartColors';

/**
 * The status counts, as clickable pills.
 *
 * Colours come from `chartColors`, not from `STATUS_MAP`. These pills are a
 * distribution — the same job the donut does, and next to it they act as its
 * legend — so they need one colour per status. `STATUS_MAP` gives eight of them
 * the same grey, which is right for a table badge and useless here.
 *
 * They wrap instead of scrolling. The row used to be `flex-nowrap
 * overflow-x-auto` with the scrollbar hidden, so past the sixth status the rest
 * were cut off at the edge with nothing saying they existed.
 *
 * @param {object} props
 * @param {number|string} props.total
 * @param {Array<{value: string, count: number}>} props.statusCount
 * @param {string} props.currentStatus - `'all'` or a `system_name`
 * @param {(status: string) => void} props.onStatusChange
 */
export const DeliveryChips = ({ total, statusCount, currentStatus, onStatusChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-2.5">
      <button
        onClick={() => onStatusChange('all')}
        className={`px-4 py-2 rounded-full text-sm font-semibold transition-all flex items-center gap-2 border
          ${currentStatus === 'all'
            ? 'bg-ninja-green text-white border-ninja-green shadow-sm'
            : 'bg-white dark:bg-[#1a1a1a] text-text-secondary border-border hover:bg-ninja-gray dark:hover:bg-[#2d2d2d]'
          }
        `}
      >
        <span className={`w-2.5 h-2.5 rounded-full ${currentStatus === 'all' ? 'bg-white' : 'bg-text-muted'}`} />
        Todos: {total}
      </button>

      {statusCount?.map((sc) => {
        const label = STATUS_MAP[sc.value]?.user_name || sc.value;
        const color = getChartColor(sc.value);
        const isActive = currentStatus === sc.value;

        return (
          <button
            key={sc.value}
            onClick={() => onStatusChange(sc.value)}
            className={`px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 transition-all border
              ${isActive ? 'shadow-sm text-white' : 'hover:opacity-80 bg-white dark:bg-[#1a1a1a] text-text-secondary dark:text-gray-300'}
            `}
            style={{
              borderColor: isActive ? color : `${color}80`,
              backgroundColor: isActive ? color : `${color}1a`,
            }}
          >
            <span
              className="w-2.5 h-2.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: isActive ? '#ffffff' : color }}
            />
            {label}: {sc.count}
          </button>
        )
      })}
    </div>
  );
};
